import { Hint, type HintPopoverPositions } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface IAddWorkedHoursHintProps {
  stepNumber: number
  position?: HintPopoverPositions
}

const AddWorkedHoursHint = ({ stepNumber, position = 'bottom left' }: IAddWorkedHoursHintProps) => {
  return (
    <Hint.Popover
      step={stepNumber}
      title={i18n.t('project_management.my_projects.hints.add_worked_hours.title')}
      description={i18n.t('project_management.my_projects.hints.add_worked_hours.description')}
      actionLabel={i18n.t('project_management.my_projects.hints.add_worked_hours.action_label')}
      position={position}
    />
  )
}

export default observer(AddWorkedHoursHint)
